// TODO: rename PORT to API_URL - it's a URL not a port number

// === BUILD-TIME CONFIG (generated by gf-build.sh) ===
// let port = 'https://genefriends.local/api'
// module.exports = {
//     PORT: port
// }

// === RUNTIME CONFIG (hot load from /config.json) ===
let _port = null;

function getPort() {
    if (!_port) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', '/config.json', false);
        xhr.send();
        _port = JSON.parse(xhr.responseText).apiBaseUrl;
    }
    return _port;
}

module.exports = {
    get PORT() { return getPort(); }
}
